module.exports = "/images/cf.svg?fb19fd0d830294000dde99b24a1b3487";